import { Config } from "config/config.type"
/** @firescoutMockVar Config.config */
const config:Config = {
  "env": "prod",
  "location": "lusini_hr-hr",
  "shopName": "lusini",
  "locale": "hr-hr",
  "rootCategoryId": "EMG",
  "orderMinimumB2C": 60,
  "availableCreditCards": [
    "MASTERCARD",
    "VISA",
    "DINERS",
    "DISCOVER"
  ],
  "links": {
    "contact": "/pomocipodrska/kontakt/"
  },
  "i18n": {
    "currency_ISO": "EUR",
    "locale": "hr-HR",
    "country": "HR"
  },
  "languages": {
    "de": "Njemački",
    "en": "Engleski",
    "fr": "Francuski",
    "es": "Španjolski",
    "it": "Talijanski",
    "nl": "Nizozemski",
    "pt": "Portugalski",
    "sv": "Švedski",
    "da": "Danski",
    "hr": "Hrvatski",
    "nb": "Norveški"
  },
  "slugifyLocale": "hr",
  "hrefLang": [
    {
      "configFolder": "lusini",
      "locale": "hr-hr",
      "hrefLang": "hr"
    }
  ],
  "baseUrl": "https://www.lusini.com",
  "functions": {
    "clientdata": "https://functions.lusini.com/.netlify/functions/clientdata",
    "newsletter": {
      "getOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-getOptInStatus",
      "createContactWithOptIn": "https://functions.lusini.com/.netlify/functions/newsletter-createContactWithOptIn",
      "setOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-setOptInStatus"
    },
    "creditsave": {
      "address": "https://functions.lusini.com/.netlify/functions/creditsafe-address"
    },
    "shareCart": {
      "POST": "https://functions.lusini.com/.netlify/functions/shareCart-POST",
      "GET": "https://functions.lusini.com/.netlify/functions/shareCart-GET"
    },
    "raffle": {
      "registration": "https://functions.lusini.com/.netlify/functions/POST-raffle-registration"
    }
  },
  "modules": {
    "onetrust": {
      "dataDomainScript": "bda0c016-94be-4fd9-943a-b9c09791a327"
    },
    "cloudinary": {
      "endpoint": "https://res.cloudinary.com/lusini/",
      "transformations": {
        "freisteller_l": "w_1500,h_1500,q_80,c_pad,f_auto",
        "freisteller_l_2": "w_1500,h_1500,q_80,c_pad,f_auto",
        "milieu_l": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "milieu_l_2": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "freisteller_m": "w_500,h_500,q_70,c_pad,f_auto",
        "freisteller_m_2": "w_500,h_500,q_70,c_pad,f_auto",
        "milieu_m": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "milieu_m_2": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "freisteller_s": "w_300,h_300,q_70,c_pad,f_auto",
        "freisteller_s_2": "w_600,h_600,q_70,c_pad,f_auto",
        "milieu_s": "w_300,h_300,g_auto,q_70,c_fill,f_auto",
        "milieu_s_2": "w_600,h_600,g_auto,q_70,c_fill,f_auto",
        "freisteller_xs": "w_50,h_50,q_50,c_pad,fl_lossy,f_auto",
        "freisteller_xs_2": "w_100,h_100,q_50,c_pad,fl_lossy,f_auto",
        "milieu_xs": "w_50,h_50,g_auto,q_50,c_fill,fl_lossy,f_auto",
        "milieu_xs_2": "w_100,h_100,g_auto,q_50,c_fill,fl_lossy,f_auto"
      },
      "fallback_product_picture": "https://res.cloudinary.com/lusini/image/upload/v1643182695/application/products/lusini-online-shop-platzhalter-produktbild-in-kuerze-hr.svg",
      "newsletter_intentlayer_picture": "https://res.cloudinary.com/lusini/image/upload/v1724665736/application/NewsletterPopupAB/discount-reduction-hr-hr.svg"
    },
    "shopware": {
      "salutations": [
        "mr",
        "ms"
      ],
      "initialSaluationId": "6d0b33d96b5b400cbabc648c0a4c3f60",
      "accessKey": {
        "b2b": "SWSC2CMJUV6EWQNCYUX12Q4FU4",
        "b2c": "SWSCYAZ5KISO3UXQ1SLNGMJDM4"
      },
      "storefrontUrl": {
        "b2b": "https://www.lusini.com/hr-hr/b2b",
        "b2c": "https://www.lusini.com/hr-hr/b2c"
      },
      "apiUrl": "https://shop-api.lusini.com/store-api"
    },
    "algolia": {
      "apiKey": "bf4bf9193d5f34cd369647376521dbc8",
      "applicationId": "WAVYBEW6OQ"
    },
    "contentful": {
      "space": "aza65graowyr",
      "environment": "master",
      "accessToken": "CiHQe6Rhx0nDcBT3Siv4qHIUk2xC6CcSwTbtIdMStyk",
      "previewToken": "J9M50p9PZokU9L3-SiDXcfDvVHpcTCzWyLSznbtHPWA"
    },
    "dyHybrid": {
      "apiKey": "e3241f26e68894b7351374710059355e2181541cd5ef10353a15507d5d1e859b",
      "campaignID": "9879543"
    },
    "trustShop": {
      "placeholderImg": "https://res.cloudinary.com/lusini/image/upload/c_scale,f_auto,h_100,w_100/v1689756686/application/icons/trustedshops-logo.svg",
      "id": "X21BE31256D11AF3EFD5EFA5B723D31D2",
      "url": "https://widgets.trustedshops.com/js/",
      "urlPostfix": ".js"
    },
    "zenloop": {
      "id": "T0RWbVpESTRZak10WlRSaU1pMDBOMlUwTFRoak9Ea3RZMlUyWm1Zek9XTTFZemsy"
    },
    "hotjar": {
      "id": 3549008,
      "version": 6
    }
  },
  "index": {
    "products": "prod_lusini_hr_HR_products",
    "productsPriceAsc": "prod_lusini_hr_HR_products_priceAsc",
    "productsPriceDesc": "prod_lusini_hr_HR_products_priceDesc",
    "categories": "prod_lusini_hr_HR_categories",
    "series": "prod_lusini_hr_HR_series",
    "productsSuggestion": "prod_lusini_hr_HR_products_query_suggestions",
    "productsLatest": "prod_lusini_hr_HR_products_noveltiesAsc",
    "productReviews": "prod_lusini_product_reviews",
    "serviceReviews": "prod_lusini_service_reviews"
  },
  "deliveryDate": {
    "shippingTooLong": 200
  },
  "colors": {
    "Bijeli": "white",
    "Crno": "black",
    "Siva": "grey",
    "Srebro": "silver",
    "Smeđa": "brown",
    "Plava": "blue",
    "Raznobojno": "multicolor",
    "Crvena": "red",
    "Bež": "beige",
    "Zelena": "green",
    "Transparentan": "transparent",
    "Žuta Boja": "yellow",
    "Zlato": "gold",
    "Naranča": "orange",
    "Ružičasta/Ljubičasta": "lilac"
  },
  "features": {
    "devMode": false,
    "trustShop": true,
    "zenloop": true,
    "qrCode": false,
    "b2c": true,
    "notificationBar": true,
    "showNewsletterIntentLayer": true,
    "userLikeWidgetUrl": "",
    "customizableUrl": "https://www.lusini.com/hr-hr/pomocipodrska/usluge/personalizacija/",
    "emarsysWebExtend": true,
    "emarsysWebExtendMerchantId": "15B4FD776807265B",
    "b2cHomePage": true,
    "cmpConsilius3dViewer": {
      "language": "en"
    }
  },
  "abTests": {},
  "showTelephoneContactOnFailedCheckoutThreshold": 0
}
export default config